export enum AccessEntityType {
	User = 'User',
	Group = 'Group',
	Team = 'Team'
}
